import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CategoryHeader = function (_a) {
    var title = _a.title, children = _a.children;
    return (_jsxs("div", { className: "flex flex-row items-center gap-1", children: [_jsx("h3", { className: "whitespace-nowrap text-sm font-semibold text-secondary", children: title }), children] }));
};
